import { getWorkerDisplayStatus } from '#pplx/frontend/apps/ask/shared/workerModel.js';
import { createContext, useContext } from 'react';
export const EMPTY_SESSION_WORKERS_SNAPSHOT = {
    workers: [],
    hasMore: false,
    loaded: false,
};
export const SessionWorkersContext = createContext(EMPTY_SESSION_WORKERS_SNAPSHOT);
export function useSessionWorkersSnapshot() {
    return useContext(SessionWorkersContext);
}
export function getSessionWorkerStatus({ snapshot, workerId, }) {
    const worker = snapshot.workers.find(({ contextUuid }) => contextUuid === workerId);
    if (!worker) {
        if (!snapshot.loaded)
            return 'starting';
        return snapshot.hasMore ? 'unknown' : 'unavailable';
    }
    return getWorkerDisplayStatus({
        agentTurnState: worker.status,
        workerState: worker.workerState,
    });
}
//# sourceMappingURL=SessionWorkersContextShared.js.map